const SET_MESSAGE = 'SET_MESSAGE';
export const setMessage = (message) => {
  return { type: SET_MESSAGE, message }
}

const SET_LOADING = 'SET_LOADING';
export const setLoading = (loading) => {
  return { type: SET_LOADING, loading }
}

const SET_TOPBAR_BUTTONS = 'SET_TOPBAR_BUTTONS';
export const setTopbarButtons = (buttons) => {
  return { type: SET_TOPBAR_BUTTONS, buttons }
}

const ADD_BREADCRUMBS_ROUTE_TITLES = 'ADD_BREADCRUMBS_ROUTE_TITLES';
export const addBreadcrumbsRouteTitles = (breadcrumbsRouteTitles) => {
  return { type: ADD_BREADCRUMBS_ROUTE_TITLES, breadcrumbsRouteTitles }
}



// WEBPACK FOOTER //
// ./src/actions/index.js